import React, { Component } from 'react'
import intl from 'react-intl-universal'
import { inject, observer, PropTypes } from 'mobx-react'
import { login } from '../api'
import { Redirect } from 'react-router'
import Input from './Input'
import 'formdata-polyfill'
import RegisterModal from '../containers/RegisterModal'
import object_value from '../api/object_value'
import { NotificationManager } from 'react-notifications'

@inject('user', 'modals')
@observer
class LoginForm extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      form_class: 'b-form',
      status: '',
      message: '',
      navigate: false
    }
  }

  // Enable browser form validation on any input change
  makeValidationVisible = () => {
    // Make validation errors visible
    if (this.state.form_class === 'b-form') {
      this.setState({form_class: this.state.form_class + ' b-form_allow-browser-validation'})
    }
  }

  // Elegant way of binding handler to (this) without `constructor(){ super() }`
  handleInput = async () => {
    this.setState({status: ''})
  }

  // Elegant way of binding handler to (this) without `constructor(){ super() }`
  handleSubmit = async (event) => {
    event.preventDefault()

    this.setState({status: 'loading'})

    const data = new FormData(event.target)
    // Display the key/value pairs
    console.log('handleSubmit() - data')
    for (let [key, val] of data.entries()) {
      console.log(key, val)
    }

    // Send a request
    let response = await login(data)
    console.log('handleSubmit() - response', response)

    // Error
    if (!response.ok) {
      let message = object_value(response, 'data.message', 'Error')
      if (message === 'Unauthorized') {
        message = 'Wrong credentials'
      }

      NotificationManager.error(message, 'Error!', 2500)

      if (this.refs.LogindForm) { // Prevent a warning - https://stackoverflow.com/a/40969739
        this.setState({
          status: 'error',
          message
        })
      }

      return false
    }

    let token = object_value(response, 'data.token')

    // No token
    if (!token) {
      NotificationManager.error('Token has not been received', 'Server error!', 2500)

      if (this.refs.LogindForm) { // Prevent a warning - https://stackoverflow.com/a/40969739
        this.setState({
          status: 'error',
          message: 'Token has not been received'
        })
      }

      return false
    }

    // Success
    NotificationManager.success('You have been signed in', 'Success!', 5000)

    if (this.refs.LogindForm) {
      this.setState({
        status: 'success',
        // message
      })
    }

    // Close the modal
    const {user, modals} = this.props

    user.setToken(token)

    console.log('LoginForm - modals:', modals)
    const navigate = modals.redirect_path

    // Redirect
    if (navigate) {
      await this.setState({navigate})
    }

    modals.setModal('')
    document.body.classList.toggle('js-modal-opened')
    document.body.scrollIntoView()
  }

  handleOnclickModal = (event) => {
    event.preventDefault()
    this.props.modals.setModal('RegisterModal')
  }

  handleOnclickForgot = (event) => {
    event.preventDefault()
    this.props.modals.setModal('ForgotPasswordModal')
  }

  render () {
    // Redirect
    // https://stackoverflow.com/a/43333330/8551889
    const { navigate } = this.state
    if (navigate) {
      return <Redirect to={navigate} push={true} />
    }

    return (
      <form ref="LogindForm"
            className={this.state.form_class}
            onInput={this.handleInput}
            onSubmit={this.handleSubmit}>

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   id='email'
                   name='email'
                   type='email'
                   required
            />
            <label className='b-form-item-label' htmlFor='email'>
              {intl.get('E-Mail')}
            </label>
          </div>
        </div>

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   id='password'
                   name='password'
                   type='password'
                   required
            />
            <label className='b-form-item-label' htmlFor='password'>
              {intl.get('Password')}
            </label>
          </div>
        </div>

        {this.state.status === 'loading' &&
        <div className='b-form-success'>Loading...</div>}

        {this.state.status === 'error' &&
        <div className='b-form-error'>{this.state.message}</div>}

        {this.state.status === 'success' &&
        <div className='b-form-success'>{this.state.message}</div>}

        {this.state.status !== 'success' &&
        <div className='b-form-row'>
          <button type='submit'
                  className='b-button b-button_primary b-button_x'
                  onClick={this.makeValidationVisible}>
            {intl.get('Login')}
          </button>
        </div>}

        <p className='text-center'>
          <button className='b-link'
                  type='button'
                  onClick={this.handleOnclickForgot}>{intl.get('Forgot password?')}</button>
        </p>

        <hr />

        <p className='text-center larger'>{intl.get('You don’t have an account yet')}?&nbsp;
          <button className='b-link'
                  type='button'
                  onClick={this.handleOnclickModal}><strong>{intl.get('Register')}</strong></button>
        </p>
      </form>
    )
  }
}

LoginForm.propTypes = {
  user: PropTypes.observableObject,
  modals: PropTypes.observableObject
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/LoginForm.js